import statsig from 'statsig-js'
import fetch from 'isomorphic-fetch'
import { mapNebulaJobToOldJob } from '../../refactory/modules/jobs/infrastructure/mappers/nebula-jobs'

const API_URL_AVT = process.env.REACT_APP_AVT_API_URL

const createRequestBody = (request) => {
  return {
    method: request.method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.body)
  }
}

const getJobs = async (params) => {
  const { allStores } = params
  if (allStores) delete params.stores
  const query = Object.keys(params)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
    .join('&')
  const requestUrl = `${API_URL_AVT}/odin/api/jobs?${query}`

  const requestBody = createRequestBody({
    method: 'GET'
  })
  return await fetch(requestUrl, requestBody)
}

const getJob = async (jobId) => {
  const isGetDetailJobByNebulaActive = statsig.checkGate('is_get_detail_job_by_nebula_active')

  if (isGetDetailJobByNebulaActive) {
    const customFields = await getJobCustomFields(jobId)
    const job = await getJobByNebula(customFields.uuid)

    return { ...job, ...customFields }
  } else {
    const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}`

    const requestBody = createRequestBody({
      method: 'GET'
    })
    return await fetch(requestUrl, requestBody)
  }
}

const getJobByUUID = async (jobUUID) => {
  const isGetDetailJobByNebulaActive = statsig.checkGate('is_get_detail_job_by_nebula_active')

  if (isGetDetailJobByNebulaActive) {
    const [job, customFields] = await Promise.all([getJobByNebula(jobUUID), getJobCustomFields(jobUUID)])

    return { ...job, ...customFields }
  } else {
    const requestUrl = `${API_URL_AVT}/odin/api/job-by-uuid/${jobUUID}`

    const requestBody = createRequestBody({
      method: 'GET'
    })
    return await fetch(requestUrl, requestBody)
  }
}

const getCities = async (params) => {
  const query = Object.keys(params)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
    .join('&')
  const requestUrl = `${API_URL_AVT}/odin/api/cities?${query}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return await fetch(requestUrl, requestBody)
}

const getOperationModels = async () => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/models`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return await fetch(requestUrl, requestBody)
}

const getJobByNebula = async (uuid) => {
  const requestUrl = `${API_URL_AVT}/nebula/jobs/${uuid}`

  const requestBody = createRequestBody({
    method: 'GET'
  })
  const result = await fetch(requestUrl, requestBody)
  const job = mapNebulaJobToOldJob(result)

  return job
}

const getJobCustomFields = async (jobIdOrUuid) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobIdOrUuid}/custom-fields`

  const requestBody = createRequestBody({
    method: 'GET'
  })
  return await fetch(requestUrl, requestBody)
}

export { getJobs, getJob, getCities, getOperationModels, getJobByUUID, getJobByNebula, getJobCustomFields }
